<script setup lang="ts">
import type { ComboboxTriggerProps } from "./combobox.types";
import { useComboboxTrigger } from "./useCombobox.Trigger";

defineOptions({ name: "ComboboxTrigger" });

const props = withDefaults(defineProps<ComboboxTriggerProps>(), {
  indicatorIcon: "chevron-down",
});

const { classes, combobox, handleClick } = useComboboxTrigger({ props });
</script>

<template>
  <button
    type="button"
    part="trigger"
    exportparts="icon"
    :class="classes"
    class="e-combobox-trigger"
    :disabled="combobox.comboboxProps.value?.disabled"
    :aria-label="combobox.isOpen.value ? 'Close' : 'Open'"
    tabindex="-1"
    @click="handleClick"
  >
    <slot>
      <e-icon exportparts="base:icon" :name="indicatorIcon" size="sm" />
    </slot>
  </button>
</template>

<style>
:host {
  display: contents;
}
</style>
